<template>
	<div id="app">
		<div class="header">
			<span class="left_txt">排课记录</span>
			<span :class="tabIndex == index ? 'active' : 'tab_day'" @click="tabs(index,item.start_time,item.end_time)" v-cloak
			 v-for="(item,index) in recordData">
				{{item.start_time}} 到 {{item.end_time}}{{item.examine}}
			</span>
			<span class="print" @click="dofn()">打印</span>
			<span class="print" @click="choseall()">全选</span>
		</div>

		<ul class="tab_ul">
			<li v-for="(item,index) in week" :class="tabIndex2 == index ? 'active2' : 'Li'" v-cloak @click="tab2(index,item.val)">
				{{item.name}}
			</li>
		</ul>

		<table class="box" border="1" cellspacing="" cellpadding="" style="width:100%">
			<tr>
				<th></th>
				<th v-for="item in titleData" style="text-align: center;">
					<h4 style="padding: 6px 0;" v-cloak>{{item.content}}</h4>
				</th>
			</tr>
			<tr v-for="(item,index) in tableData">
				<td width="7%">{{item.t[0]}}--{{item.t[1]}}</td>
				<td v-for="(data1,index) in item" v-cloak v-if="data1 !== '' && index !== 't'">
					<div class="td_content">
						<a @click="details(data1.pk_id)">{{data1.kc_name}}</a><br />
						<input type="checkbox" name="needprint" :value="data1.pk_id" class="needprint" />
						<span>班内人数：</span>
						<span>{{data1.guding}}</span><br />
						<span>{{data1.username}}</span><br />
					</div>
					<!--<div v-else></div>-->
				</td>
			</tr>
		</table>
		<div class="none-data" v-show="data_state" style="width: 100%">暂无数据</div>

		<!--个人详情-->
		<el-dialog :visible.sync="centerDialogVisible" width="32%" custom-class="kechengxiangqing" center>
			<div slot="title" style="background: #8CBB77;width: 100%;height: 50px;line-height: 55px;font-size: 18px">
				课程详情
				<!--<img class="close-img" src="/static/qmsj/img/paike/close.png" @click="centerDialogVisible = false"/>-->
			</div>
			<h4 style="text-align: center;font-size: 15px;margin-bottom: 10px;">
				{{details_data.kc_name}}
			</h4>

			<div class="line">
				<!--<span>月龄段：{{details_data.yuelingz}}</span>-->
				<span>教室：{{details_data.content}}</span>
				<span>班主任：{{details_data.username}}</span>
			</div>
			<!--<div class="line">-->
				<!--&lt;!&ndash;<span>耗课：{{details_data.xiaoke}}</span>&ndash;&gt;-->
				<!--<span>.</span>-->
				<!--<span>班主任：{{details_data.username}}</span>-->
			<!--</div>-->

			<div class="line">课程周期：{{details_data.zhouqi}}</div>
			<div class="line" style="display: inline-block;">固定班学生({{details_data.guding}})：</div>
			<span class="btn" style="padding:0" v-show="print_show" @click="fn(details_data.pk_id)">打印签到表</span>
			<!--<span class="btn" v-show="print_show2" @click="prin_t">打印签到表</span>-->
			<span style="height: 20px;"></span>
			<div class="student">
				<p v-for="item in details_name" v-cloak>
					{{item.baobao_name}}
					<span @click="cancel(item.user_id,details_data.pk_id)">x</span>
				</p>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="cancel_dialog" width="30%">
			<div slot="title" style="background: #f1f1f1;width: 100%;height: 50px;line-height: 55px;font-size: 18px;text-align: center;">
				通知</div>
			<span>是否取消固定班？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancel_dialog = false">取 消</el-button>
				<el-button type="success" @click="confirm_cancel">确 定</el-button>
			</span>
		</el-dialog>

		<!--打印签到表-->
		<div v-show="false" class="print_box" id="print_div">
			<table border="" style="width: 100%;height: 100%; hmargin-bottom: 30px;" cellspacing="" cellpadding="">
				<thead>
					<tr>
						<th style="font-size: 28px;padding: 14px 0;" colspan="10">
							{{print_title}}
						</th>
					</tr>
				</thead>

				<tbody>
					<tr>
						<th style="padding: 9px 0;">序号</th>
						<th>会员姓名</th>
						<th>家长姓名</th>
						<th>电话</th>
						<th v-for="item in print_time">
							{{item}}
						</th>
					</tr>
					<tr v-for="item in print_data">
						<td style="text-align: center;padding: 9px 0;">{{item.xu}}</td>
						<td style="text-align: center;">{{item.baobao_name}}</td>
						<td style="text-align: center;">{{item.namez}}</td>
						<td style="text-align: center;">{{item.phonez}}</td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
					</tr>
				</tbody>
			</table>

			<table border="" v-show="table_show" style="width: 100%;height: 100%;" cellspacing="" cellpadding="">
				<thead>
					<tr>
						<th style="font-size: 26px;padding: 14px 0;" colspan="10">
							{{print_title2}}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th style="padding: 9px 0;">序号</th>
						<th>会员姓名</th>
						<th>家长姓名</th>
						<th>电话</th>
						<th v-for="item in print_time2">
							{{item}}
						</th>
					</tr>
					<tr v-for="(item,index) in print_data2">
						<td style="text-align: center;padding: 9px 0;">{{item.xu}}</td>
						<td style="text-align: center;">{{item.baobao_name}}</td>
						<td style="text-align: center;">{{item.namez}}</td>
						<td style="text-align: center;">{{item.phonez}}</td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
						<td style="text-align: center;"></td>
					</tr>
				</tbody>
			</table>
		</div>
		<!--课程表 s 1-->
		<div id='kcb' class="doubi" style="display: block;">
		</div>
		<!--课程表 e 1-->

	</div>
</template>

<script>
	export default {
		data() {
			return {
				tokenVal: '',
				recordData: [], //排课记录
				titleData: [], //教室数据
				tableData: [], //表格数据
				details_data: [], //详情数据
				details_name: [], //名单
				tabIndex: 0, //tab1
				tab1_state: true,
				tabIndex2: 0, //tab2
				s_time: '', //开始时间
				e_time: '', //结束时间
				c_time: '', //课程时间
				f_time: '',
				l_time: '',
				data1: [],
				day: 1, //周几
				time_state: false,
				week: [{
						name: '星期一',
						val: 1
					},
					{
						name: '星期二',
						val: 2
					},
					{
						name: '星期三',
						val: 3
					},
					{
						name: '星期四',
						val: 4
					},
					{
						name: '星期五',
						val: 5
					},
					{
						name: '星期六',
						val: 6
					},
					{
						name: '星期日',
						val: 7
					}
				],
				centerDialogVisible: false, //课程详情
				data_state: false, //暂无数据
				print_title: '', //打印
				print_data: [],
				print_time: [],
				print_title2: '',
				print_data2: [],
				print_time2: [],
				table_show: false, //打印表格
				print_show: true, //打印按钮
				print_show2: false,
				content_state: true,
				paike_id: '', //排课ID
				cancel_dialog: false, //取消固定班
				ids: '', //排课
				pai_id: '',
			}
		},
		mounted() {
			let self = this;
			self.tokenVal = $.cookie('token');
			this.work_s()
		},
		methods: {
			work_s: function() {
				let self = this;
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/check_see',
					type: 'post',
					data: {
						token: self.tokenVal
					},
					dataType: "json",
					success: function(data, status) {

						self.recordData = data.se_time
						self.titleData = data.classroom
						if (data.data != '' && self.tab1_state == true) {
							self.tableData = data.data
							self.data_state = false
							for (let i = 0; i < self.tableData.length; i++) {
								self.data1 = self.tableData[i]
								self.f_time = self.tableData[i].t[0]
								self.l_time = self.tableData[i].t[1]
								self.time_state = true
							}
						} else {
							self.tableData = []
							self.data1 = []
							self.time_state = false
							self.data_state = true
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},

			dofn: function() {
				let self = this;
				var pk_id = '';
				$.each($('.needprint:checked'), function() {
					pk_id += ',' + $(this).val();
				})
				self.fn(pk_id);
			},
			//教室全选
			choseall(){
                let self = this;
                $.each($('.needprint'), function() {
					$(this).prop('checked','checked')
                })
			},
			jump: function(d) {
				this.$router.push(d)
			},
			fn: function(pkid) {
				let self = this;
				$.ajax({
					type: "post",
					url: process.env.apiUrl + "saas/paike/dayinq",
					data: {
						"token": self.tokenVal,
						"pk_id": pkid,
					},
					success: function(e) {
						var str1 = ''
						for (var i = 0; i < e.length; i++) {

							var strq = ''
							for (var q = 0; q < 14; q++) {
								strq += '<tr ><td style="width:5% ;height:12.3mm;">' + e[i].ren[q].xu
								+ '</td><td style="width:10% ;height:12.3mm;">' + e[i].ren[q].baobao_name
								+ '</td><td style="width:10% ;height:12.3mm;">' + e[i].ren[q].namez
								+'</td><td style="width:10% ;height:12.3mm;">' + e[i].ren[q].phonez +
								'</td><td></td><td></td><td></td><td></td><td></td><td></td></tr>'

							}
							var str3 = ''
							if (e[i].ri.length < 6) {
								var mm = 6 - e[i].ri.length;
								for (var j = 0; j < mm; j++) {
									str3 += '<td style="width:10% ;height:12.3mm;"></td>'
								}
								/* alert(str3)*/
							}

							var str2 = ''
							for (var k = 0; k < e[i].ri.length; k++) {
								str2 += '<td style="width:10% ;height:12.3mm;">' + e[i].ri[k] + '</td>'
							}
							var strww = str2 + str3;

							str1 += ' <table class="dayin11"   border="1" style="text-align: center;margin:20px;width: 285mm;height: 210mm;">' +
								'<tr><td colspan="10" style="height:15mm;"><h1>' + e[i].biao + '</h1></td></tr>' +
								'<tr><td>序号</td><td>会员姓名</td><td>家长姓名</td><td>电话</td>'
								 + strww + '</tr>'
								  + strq +
								'</table>'
							if(i< e.length-1 ){
							    str1 += '<div style="height:5px;"></div>';
							}
						}
						$('#kcb').append(str1);

						if (2 < 3) {
							//                  $('#querendy').modal({"backdrop":"static"});
							$('#kcb').css('display', 'block')
							//                  $('#dyquer').click(function(){
							//                      $('#querendy').modal('hide');
							let print_box = document.getElementById('kcb');
							let newContent = $('#kcb').clone();
							$('body').empty();
							$('body').append(newContent)
							let oldContent = document.body.innerHTML;
							// document.body.innerHTML = newContent;
							print.portrait=false
							window.print();
							// self.jump('look_class');
							window.location.reload();
							//  document.body.innerHTML = oldContent;
							// self.jump('look_class');
							//                  })
						} else {
							$('#xuantime').modal({
								"backdrop": "static"
							});
						}

					}
				})

			},
			//tab切换
			tabs(i, s_time, e_time) {
				let that = this
				that.tabIndex = i

				that.s_time = s_time
				that.e_time = e_time
				that.get_val()
				that.tab1_state = true
			},
			tab2(i, day) {
				let that = this
				that.tabIndex2 = i

				that.day = day
				that.get_val()
			},
			//获取table数据
			get_val() {
				let that = this
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/check_see',
					type: 'post',
					data: {
						s_time: that.s_time,
						e_time: that.e_time,
						zz: that.day,
						token: that.tokenVal
					},
					dataType: "json",
					success: function(data, status) {
						if (data.data != '' && that.tab1_state == true) {
							that.tableData = data.data
							that.data_state = false
							for (let i = 0; i < that.tableData.length; i++) {
								that.data1 = that.tableData[i]
								that.f_time = that.tableData[i].t[0]
								that.l_time = that.tableData[i].t[1]
								that.time_state = true
							}
						} else {
							that.tableData = []
							that.data1 = []
							that.time_state = false
							that.data_state = true
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
			//查看个人详情
			details(id) {
				this.centerDialogVisible = true
				this.paike_id = id

				let that = this
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/details',
					type: 'post',
					data: {
						pk_id: id,
						token: that.tokenVal
					},
					dataType: "json",
					success: function(data, status) {
						that.details_data = data.ge
						that.details_name = data.ren
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},

			//打印签到表
			print_sign(id) {
				this.print_show = false
				this.print_show2 = true
				let that = this
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/dayinq',
					type: 'post',
					data: {
						pk_id: id,
						token: that.tokenVal
					},
					dataType: "json",
					success: function(data, status) {
						that.print_title = data[0].biao
						that.print_data = data[0].ren
						that.print_time = data[0].ri
						if (data.length > 1) {
							that.table_show = true
							that.print_title2 = data[1].biao
							that.print_data2 = data[1].ren
							that.print_time2 = data[1].ri
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
				//打印签到表
				setTimeout(function() {
					this.print_show = true
					this.print_show2 = false
					let print_box = document.getElementById('print_div');
					let newContent = print_box.innerHTML;
					let oldContent = document.body.innerHTML;
					document.body.innerHTML = newContent;
					print.portrait=false
					window.print();
					window.location.reload();
					document.body.innerHTML = oldContent;
					return false;
				}, 500)
			},
			//取消固定班
			cancel(id, p_id) {
				this.cancel_dialog = true
				this.ids = id
				this.pai_id = p_id
			},
			confirm_cancel() {
				this.cancel_dialog = false
				let that = this
				$.ajax({
					url: process.env.apiUrl + 'saas/paike/cancel',
					type: 'post',
					data: {
						pk_id: that.pai_id,
						user_id: that.ids,
						token: that.tokenVal
					},
					dataType: "json",
					success: function(data, status) {
						if (data.status == 1) {
							that.details(that.paike_id)
							that.get_val()
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			}
		}
	}
</script>
<style media="print">
	@page {
		size: auto;
		/* auto is the initial value */
		margin: 0mm;
		/* this affects the margin in the printer settings */
	}
</style>
<style scoped="scoped" lang="less">
	#app {
		margin-top: 40px;
		padding: 0 20px;
	}

	.header {
		height: 44px;
		line-height: 40px;
		margin-bottom: 20px;

		.left_txt {
			border-left: 4px solid #77c5c5;
			font-size: 14px;
			padding-left: 8px;
		}

		.tab_day {
			cursor: pointer;
			font-size: 12px;
			/*color: #8bcbcd;*/
			height: 24px;
			line-height: 24px;
			padding: 0 15px;
			/*background-color: #e9f5f3;*/
			display: inline-block;
			border-radius: 5px;
			margin-left: 3%;
			border: 1px solid #dcdfe6;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		}

		.active {
			/*background-color: #7ac4c7;*/
			cursor: pointer;
			font-size: 12px;
			color: #8CBB77;
			height: 24px;
			line-height: 24px;
			padding: 0 15px;
			display: inline-block;
			border-radius: 5px;
			margin-left: 3%;
			border: 1px solid #dcdfe6;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		}

		.print {
			color: white;
			cursor: pointer;
			letter-spacing: 4px;
			float: right;
			width: 76px;
			height: 26px;
			line-height: 26px;
			text-align: center;
			margin-right: 1%;
			background: #8CBB77;
			border-radius: 13px;
			margin-top: 11px;
		}

	}

	.tab_ul {

		.Li {
			float: left;
			list-style: none;
			width: 14%;
			background: #f1f1f1;
			text-align: center;
			line-height: 32px;
			cursor: pointer;
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
			margin-right: 2px;
		}

		.active2 {
			float: left;
			list-style: none;
			width: 14%;
			background: #8CBB77;
			text-align: center;
			color: white;
			line-height: 32px;
			cursor: pointer;
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
			margin-right: 2px;
		}

	}

	.box {
		width: 99%;
		border: 2px solid #f1f1f1;
		text-align: center;
		border-collapse: collapse;
		font-size: 14px;

		.td_content {
			position: relative;
			height: 65px;
			line-height: 21px;

			a {
				text-decoration: underline;
				font-weight: bold;
				cursor: pointer;
			}

			input {
				zoom: 140%;
				position: absolute;
				right: 1px;
				top: 2px;
			}

		}
	}

	.p_head {
		position: absolute;
		top: -55px;
		left: -25px;
		background: #f1f1f1;
		width: 100%;
		padding: 12px 25px;
		text-align: center;
		font-size: 18px;
	}

	.close-img {
		width: 20px;
		position: absolute;
		top: -41px;
		right: 0;
		cursor: pointer;
	}

	.btn {
		color: white;
		cursor: pointer;
		letter-spacing: 4px;
		float: right;
		width: 150px;
		height: 26px;
		line-height: 26px;
		text-align: center;
		margin-right: 5%;
		background: #8CBB77;
		border-radius: 13px;
	}

	.none-data {
		width: 98.1%;
		border: 2px solid #f1f1f1;
		text-align: center;
		border-collapse: collapse;
		font-size: 14px;
		border-top: 0;
		padding: 8px 3px;
	}

	.line {
		line-height: 27px;

		span {
			display: inline-block;
			width: 48%;
		}

	}

	.student {
		width: 100%;
		font-size: 15px;
		margin-top: 5px;
		height: 80px;
		overflow-y: scroll;

		p {
			float: left;
			display: inline-block;
			font-size: 14px;
			margin-right: 20px;
			line-height: 30px;
			overflow: hidden;

			span {
				display: inline-block;
				width: 20px;
				height: 20px;
				margin-left: 5px;
				border-radius: 10px;
				background: red;
				color: #fff;
				line-height: 20px;
				text-align: center;
				cursor: pointer;
			}

		}
	}

	.print_box {
		width: 100%;
		height: 100%;

		.title {
			text-align: center;
			border: 1px solid black;
			border-bottom: 0;
			font-size: 26px;
			padding: 3px 0;
		}

		table {
			width: 100%;
			text-align: center;

			td {
				padding: 5px 0;
			}

		}
	}
	.dayin11{
		table {
			td {
				width: 10%;
				padding: 30px 0;
			}
		}}
	.kechengxiangqing .el-dialog__header {
		background: rgb(253, 176, 106);
		padding: 0 !important;
	}

	.doubi table tr td {
		height: 40px;
		width: 100px;
	}

	.doubi table tr td:nth-of-type(1) {
		width: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/xuanke/look_class.vue